export default __webpack_public_path__ + "static/media/icon_like-3.d1fda31f.svg";